import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BaseUsersState } from '../reducers/base-user.reducer';

const getUsersState = createFeatureSelector<BaseUsersState>('users');
export const getAdminList = createSelector(getUsersState, (state) => state.adminList);
export const getUserList = createSelector(getUsersState, (state) => state.userList);
export const getAdminAndUserList = createSelector(getUsersState, (state) => state.adminAndUserList);
export const getUserGroups = createSelector(getUsersState, (state) => state.userGroups);
export const getUserGroupsStatus = createSelector(getUsersState, (state) => state.userGroups.ok);
export const getGroup = createSelector(getUsersState, (state) => state.userGroup);
export const getGroupCrud = createSelector(getUsersState, (state) => state.userGroup.crud);
export const getUserInactiveFilter = createSelector(getUsersState, (state) => state.userFilter.filterActive);
